import React from 'react';
import ReactDOM from 'react-dom';
import Facility from './facility.js';

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.getElementById('facility')) {
    ReactDOM.render(
      <Facility></Facility>,
      document.getElementById('facility')
    );
  }
})
